import * as z from "zod";

export const generateBomInputDemand = {
  name: "generateBomInputDemand" as const,
  input: z.object({}),
  output: z.object({ csv: z.string(), distinctOpenFgCount: z.number() }),
};
